'use strict';
const angular = require('angular');

export class videoPlayerComponent {

  constructor($sce) {
    'ngInject';

    this.$sce = $sce;
  }

  $onInit() {
    this.config = {
      sources: [
        {src: this.$sce.trustAsResourceUrl(this.url), type: "video/mp4"}
      ]
    };
  }
}

export default angular.module('conduuApp.videoPlayer', [])
  .component('videoPlayer', {
    template: require('./video-player.component.html'),
    bindings: {
      url: '@'
    },
    controller: videoPlayerComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/video-player/video-player.component.js